import type { SxProps } from '@mui/material';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import React from 'react';
import { ceraProBold, openSans, vars } from '../../../Theme';

const dialogSx: SxProps = {
    '& .MuiDialog-paper': {
        width: '90%',
        minWidth: '350px',
        maxWidth: '560px',
        padding: '24px 24px 8px 24px',
        borderRadius: '4px',
        border: `1px solid ${vars.midGray}`,
        background: vars.white,
        boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.30), 0px 4px 8px 3px rgba(0, 0, 0, 0.15)',
    },
};
const titleSx: SxProps = {
    ...ceraProBold,
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    p: 0,
    pb: 2,
};
const bodySx: SxProps = {
    ...openSans,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
};
const buttonSx: SxProps = {
    ...ceraProBold,
    textTransform: 'none',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    color: vars.font,
    padding: '10px 12px',
};

export default ({
    isOpen,
    onClose,
    onConfirm,
    onCancel,
    dialogTitle,
    dialogBody,
    confirmText,
    cancelText,
    isActionDisabled,
}: IAlertModalDialogProps) => {
    return (
        <Dialog open={isOpen} onClose={onClose} sx={dialogSx}>
            <DialogTitle sx={titleSx}>{dialogTitle}</DialogTitle>
            <DialogContent sx={{ px: 0 }}>
                <Typography sx={bodySx}>{dialogBody}</Typography>
            </DialogContent>
            <DialogActions sx={{ gap: 1, p: 0 }}>
                <Button
                    variant={'text'}
                    onClick={onCancel}
                    disabled={isActionDisabled}
                    sx={buttonSx}
                >
                    {cancelText}
                </Button>
                <Button
                    variant={'text'}
                    onClick={onConfirm}
                    disabled={isActionDisabled}
                    sx={{ ...buttonSx, color: vars.mainGreen }}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export interface IAlertModalDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    onCancel: () => void;
    dialogTitle: string;
    dialogBody: string;
    confirmText: string;
    cancelText: string;
    isActionDisabled: boolean;
}
